export default "__VITE_ASSET__CDc3JZUF__"